import { Global } from '@emotion/react'

import GlobalStyle from 'styles/globalStyle'
export function AppGlobalStyle() {
  return <Global styles={GlobalStyle} />
}
